import { render, staticRenderFns } from "./SimpleDiagram.vue?vue&type=template&id=5d6ac780&"
import script from "./SimpleDiagram.vue?vue&type=script&lang=js&"
export * from "./SimpleDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports